import * as React from 'react';
import { useState } from 'react';
import { format } from 'date-fns';

import t from './locales';
import Button from '../Shared/Button';
import { CURRENT_CART_VERSION, DATE_FORMAT } from './constants';
import { ICartItems, IPrice, IPeople, IInsuranceOrderItem, IResort } from './types';
import { retrieveCartItems, storeCartItems } from './helpers';
import { validateInsuranceOrderRequiredFields } from './validations';

// Fake API integration for new.
const syncCart = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, 1000);
  });
};

interface IProps {
  itemId: string;
  itemName: string;
  people: IPeople;
  price: IPrice;
  selectedDateList: Date[];
  resort?: IResort;
}

const InsuranceCartButton: React.FC<IProps> = (props) => {
  const { itemId, itemName, people, price, selectedDateList, resort } = props;
  const [isLoading, toggleLoading] = useState(false);
  const url = new URL(window.location.href);

  const handleClick = async (event: React.MouseEvent): Promise<void> => {
    event.preventDefault();
    if (isLoading) { return; }
    if (!validateInsuranceOrderRequiredFields(props)) { return; }
    toggleLoading(true);
    const firstDate = selectedDateList[0];
    const lastDate = selectedDateList.length > 1 ? selectedDateList[selectedDateList.length - 1] : firstDate;
    const prevCartItems: ICartItems = retrieveCartItems(CURRENT_CART_VERSION);
    const insuranceOrderItem: IInsuranceOrderItem = {
      itemId,
      itemName,
      people,
      price,
      checkInDate: format(firstDate, DATE_FORMAT),
      checkOutDate: format(lastDate, DATE_FORMAT),
      resort,
      type: "InsuranceOrder",
    };
    const cartItems = { ...prevCartItems, insuranceOrderItems: [
      ...(prevCartItems.insuranceOrderItems || []), insuranceOrderItem
    ] };
    await syncCart();
    storeCartItems(cartItems);
    toggleLoading(false);
  };

  return (
    // snow-cart-button = gtmのカートインイベント用のクラス
    // TODO: クラス以外の方法でトリガーする
    <Button href="#" onClick={handleClick} isLoading={isLoading} className="snow-cart-button">
      {t.addToCart()}
    </Button>
  );
}

export default InsuranceCartButton;
